import {
  CreateUpsellDiscountDocument,
  GetUpsellDiscountsDocument,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'
import { useQuery } from 'modules/core/hooks/useQuery'

type Props = {
  moduleName: string
  moduleSlug?: string
}

const useModuleDiscount = ({ moduleName, moduleSlug }: Props) => {
  const {
    data: discountData,
    loading: discountLoading,
    refetch,
  } = useQuery(GetUpsellDiscountsDocument, {
    variables: {
      module: moduleName,
    },
  })

  const discount = discountData?.upsell?.upsellDiscountsConnection?.nodes?.[0]

  const [createUpsellDiscount, { loading: createDiscountLoading }] = useMutation(
    CreateUpsellDiscountDocument,
    {
      extractorFn: (data) => data.upsellMutations.createUpsellUpsellDiscount,
    }
  )

  const createDiscount = ({ isAutomatedDiscount }: { isAutomatedDiscount: boolean }) => {
    return createUpsellDiscount({
      variables: {
        discountType: 'abandoned_cart',
        isAutomatedDiscount,
        module: moduleName,
        moduleName: moduleName,
        moduleSlug: moduleSlug || '',
      },
    })
  }

  return {
    discount,
    createDiscount,
    createDiscountLoading,
    discountLoading,
    refetchDiscounts: refetch,
  }
}

export default useModuleDiscount
